<template>
  <div @scroll="handleScroll">
    <header class="header-principal">
      <router-link to="/" class="holder-logo">
        <div class="logo">
          <img src="../../../assets/imgs/logo_vivo_ligado_amarelo_branco.png" alt />
        </div>
      </router-link>
      <NavMain />
      <!-- <NavegacaoPrincipal /> -->
      <NavegacaoMobile />
      <transition name="fade">
        <div class="fundo-scroll" v-if="scrolled"></div>
        <!-- <div class="fundo-scroll" :style="scrolled === true ? 'opacity: 100' : 'opacity: 0'"></div> -->
      </transition>
    </header>
  </div>
</template>

<script>
import NavMain from '@/components/layout/header/NavMain.vue';
import NavegacaoPrincipal from '@/components/layout/header/NavegacaoPrincipal.vue';
import NavegacaoMobile from '@/components/layout/header/NavegacaoMobile.vue';
import { includes } from 'lodash';
// import logo from '@/assets/imgs/logo_vivo_ligado_.svg';

export default {
  name: 'MainHeader',
  data() {
    return {
      scrolled: false,
    };
  },
  components: {
    NavMain,
    NavegacaoPrincipal,
    NavegacaoMobile,
  },
  computed: {
    scrollHeader() {
      return this.rolagem;
    },
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 40;
    },
    handlePage() {
      // const [, route] = this.$route.matched;
      // if (includes(route.name, 'vivo.consulta')) {
      //   this.$router.push({ name: 'vivo.consulta.home' });
      //   return false;
      // }
      this.$router.push('/');
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    $route: function(after) {
      console.log(after);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

header {
  @extend %flex;
  @extend %direction-row;
  @extend %justify-center;
  @extend %align-items-center;
  user-select: none;
  z-index: 10000;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 10px 0px;
  transition: all 0.5s ease-in-out;

  & .holder-logo {
    z-index: 10000;
  }

  & .logo img {
    @extend %flex;
    @extend %justify-center;
    @extend %align-items-center;
    width: 180px;
    height: 100%;
    margin-right: 20px;
  }
}

.fundo-scroll {
  @extend %gradiente_twilight;
  width: 100%;
  height: 85px;
  opacity: 0.99;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

@media all and (min-width: 300px) and (max-width: 1160px) {
  header {
    justify-content: space-between;
    padding: 15px 0px;
    max-width: 100vw;

    & .logo img {
      z-index: 50000;
      margin-left: 20px;
      width: 174px;
    }
  }

  .fundo-scroll {
    max-height: 75px;
  }
}

@media all and (min-width: 680px) and (max-width: 1160px) {
  header {
    justify-content: space-between;
    padding: 15px 0px;
    max-width: 100vw;

    & .logo img {
      margin-left: 40px;
      width: 280px;
    }
  }

  .fundo-scroll {
    max-height: 100px;
  }
}
</style>
